module.exports = __webpack_public_path__ + "static/media/menuBtn.97ecb596.svg";